import React from 'react';
import {Trans} from 'react-i18next';
import {IInvalidPasswordNotification} from '../../../incase-domain/notification';

interface IInvalidPasswordNotificationTextProps {
    notification: IInvalidPasswordNotification;
}

function InvalidPasswordNotificationText({notification}: IInvalidPasswordNotificationTextProps): JSX.Element | null {
    const getNotificationText = (numberOfDaysLeft: number): string => {
        if (numberOfDaysLeft > 1) {
            return 'notifications.invalidPassword.requestMoreThenOneDay';
        }
        if (numberOfDaysLeft === 1) {
            return 'notifications.invalidPassword.requestOneDay';
        }
        return 'notifications.invalidPassword.requestLessThenOneDay';
    };

    return (
        <Trans
            i18nKey={getNotificationText(notification.numberOfDaysLeft) as never}
            components={{bold: <strong />}}
            values={{days: notification.numberOfDaysLeft}}
        />
    );
}

export default InvalidPasswordNotificationText;
